export const formatSumBySeparatingSpace = (sum: string | number) => {
  if (!sum) return sum;

  if (typeof sum === "number") {
    sum = Math.round(sum);
  }

  return sum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

export const getSplitItem = (
  value: string | null,
  index: number = 0,
  separator = "*"
): string => {
  if (typeof value !== "string" || null) return "";
  const hasAsterisk = value.includes("*");
  if (hasAsterisk) {
    const sp = value.split(separator);
    return sp[Math.min(index, sp.length - 1)];
  } else {
    const sp = value.split("/");
    return sp.pop() || "";
  }
};
